import {Component, Input, OnInit} from "@angular/core";
import {ISourceQuestion} from "../../calculations/calculation/calculation.component";
import {ConfigStateService} from "../../../../app/config/config-state.service";
import {Tenant} from "../../../../shared/types/tenant.enum";

@Component({
    selector: 'app-calc-source-question',
    templateUrl: './calc-source-question.component.html',
    styleUrls: ['./calc-source-question.component.scss'],
    standalone: false
})
export class CalcSourceQuestionComponent implements OnInit {
  @Input() sourceQuestion: ISourceQuestion;
  @Input() prefix?: string;
  showQuestionId: boolean;

  constructor(private config: ConfigStateService) { }

  ngOnInit() {
    this.showQuestionId = this.config.tenant !== Tenant.AU;
  }

  getType(q: ISourceQuestion) {
    const dataType = q.dataType.toLowerCase();
    if (dataType === "float" || dataType === "integer") {
      return "N";
    } else if (dataType === "string") {
      return "S";
    } else if (dataType === "boolean") {
      return "B";
    } else if (dataType === "date") {
      return "D";
    } else if (dataType === "table") {
      return "T";
    } else {
      return "?";
    }
  }
}
